module.exports = __webpack_public_path__ + "img/sponsor-bishop-logo.e8891442.jpg";